export enum ProductKind {
    Merchandize = 'Merchandize',
    Service = 'Service'
}
